import React from 'react';
import {
  StyleSheet,
  Text,
  TextInput,
  View,
} from './components/base_components';

import { BusyOverlay, useBusy } from './components/busy_component';
import StandardScreen from './components/standard_screen';
import TextButton from './components/buttons/text_button';
import TitleActionLine from './components/title_action_line';
import StandardBoxList from './components/standard_box_list';

import UserStore from './stores/user_store';
import OrgStore from './stores/org_store';

const styles = StyleSheet.create({
  orgListScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  dialog: {
    marginLeft: '2rem',
    marginBottom: '2rem',
    flexDirection: 'column',
  },
  text: {
    marginTop: '1em',
    fontSize: '1.5em',
  },
  detail: {
    marginTop: '1em',
    fontSize: '1.3em',
  },
  input: {
    alignSelf: 'stretch',
    maxWidth: '40rem',
    marginTop: '1rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: '4rem',
    color: '#555',
    fontSize: '1.5rem',
    borderRadius: '0.5rem',
    borderWidth: 1,
    borderColor: '#ccc',
    backgroundColor: '#f5f5f5',
  },
  button: {
    marginTop: '1rem',
    alignSelf: 'flex-start',
  },
  actionButton: {
    marginLeft: '1rem',
  },
});

export default function OrgListScreen() {
  const [is_busy, setBusy, clearBusy] = useBusy();
  const current_org = UserStore.useOrg();
  const user = UserStore.useUser();
  const [org_name, setOrgName] = React.useState('');
  const [selected, setSelected] = React.useState([]);

  const selected_org = user?.org_list?.[selected[0]];

  function _onCreatePress() {
    if (org_name && setBusy()) {
      OrgStore.createOrg({ org_name }, (err) => {
        if (err === 409) {
          window.alert('Organization name already in use.');
        } else if (err) {
          window.alert('Create failed, please try again.');
        } else {
          window.alert('Org created!');
        }
        clearBusy();
      });
    }
  }
  function _onLeavePress() {
    if (selected_org?.is_admin) {
      window.alert("Sorry, you can't leave an org if you're an admin.");
    } else {
      const msg = `Are you sure you want to leave ${selected_org.org_name}?`;
      const yes = window.confirm(msg);
      if (yes && setBusy()) {
        OrgStore.leaveOrg({ org_id: selected_org.org_id }, (err) => {
          if (err) {
            window.alert('Leave org failed, please try again.');
          } else {
            window.alert('Org left!');
          }
          clearBusy();
        });
      }
    }
  }
  function _onSwitchPress() {
    UserStore.setCurrentOrgId(selected_org?.org_id);
  }

  const buttons = (
    <>
      <TextButton
        style={styles.actionButton}
        text='Switch To Org'
        disabled={!selected_org || selected_org?.org_id === current_org.org_id}
        onPress={_onSwitchPress}
      />
      <TextButton
        style={styles.actionButton}
        text='Leave Org'
        type='danger'
        disabled={!selected_org}
        onPress={_onLeavePress}
      />
    </>
  );

  const rows = user?.org_list?.map?.((org) => {
    const active = org.org_id === current_org.org_id ? ' (Active)' : '';
    return [`${org.org_name}${active}`, org.is_admin ? 'Admin' : 'Member'];
  });
  return (
    <View style={styles.orgListScreen}>
      <StandardScreen>
        <TitleActionLine title='Organizations' />
        <StandardBoxList
          title='Your Organizations'
          headers={['Name', 'Role']}
          buttons={buttons}
          rows={rows}
          selected={selected}
          onChange={setSelected}
          singleSelect={true}
        />
        <StandardBoxList title='Signup a New Organization'>
          <View style={styles.dialog}>
            <Text style={styles.detail}>
              You will need to provide payment details to use your new
              organization account.
            </Text>
            <Text style={styles.text}>Organization Name</Text>
            <TextInput
              style={styles.input}
              placeholder='name'
              value={org_name}
              onChangeText={setOrgName}
            />
            <TextButton
              style={styles.button}
              text='Signup'
              onPress={_onCreatePress}
            />
          </View>
        </StandardBoxList>
      </StandardScreen>
      <BusyOverlay isBusy={is_busy} />
    </View>
  );
}
